module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ja":{"h-1":"特徴","f-1":{"head":"全国の倉庫に\\nすぐアプローチ","leading":"WareXのスタッフのサポート付きで最適な倉庫を探せます。"},"f-2":{"head":"契約締結まで\\n無料","leading":"成約に至った場合のみ、倉庫利用に関する料金が発生いたします。"},"f-3":{"head":"輸配送や\\n流通加工も可能","leading":"保管だけでなく、貨物の輸配送や検品、梱包、デバンニング作業も対応できる倉庫をお探しいたします。"}}}')
  delete Component.options._Ctor
}
